<template>
  <div class="forbidden-container">
    <div class="forbidden-box">
      <h1>🚫 Forbidden Access</h1>
      <p>
        Access denied. You might not have the required permissions,
        <br />
        or the application is currently running in restricted mode.
      </p>
      <router-link to="/" class="home-button">Back to Home</router-link>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'ForbiddenAccess',
  };
</script>

<style scoped>
  .forbidden-container {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100vh;
    background-color: #fdf2f2;
  }

  .forbidden-box {
    text-align: center;
    background: #fff;
    border: 1px solid #f5c2c7;
    padding: 40px;
    border-radius: 12px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
    max-width: 480px;
    width: 90%;
  }

  h1 {
    color: #d32f2f;
    font-size: 28px;
    margin-bottom: 20px;
  }

  p {
    color: #555;
    font-size: 16px;
    margin-bottom: 30px;
    line-height: 1.5;
  }

  .home-button {
    display: inline-block;
    padding: 10px 20px;
    background-color: #1976d2;
    color: #fff;
    text-decoration: none;
    border-radius: 6px;
    transition: background 0.3s;
  }

  .home-button:hover {
    background-color: #125ea5;
  }
</style>
